import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectOverviewComponent } from './project-overview/project-overview.component';
import { ProjectService } from 'src/app/core/services/project.service';
import { ProjectsRoutingModule } from './projects-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CreateAssignmentComponent } from './assignments/create-assignment/create-assignment.component';
import { AssignmentService } from 'src/app/core/services/assignment.service';
import { AssignmentOverviewComponent } from './assignments/assignment-overview/assignment-overview.component';
import { CoreModule } from 'src/app/core/core.module';
import { ProjectsComponent } from './projects.component';
import { CreateProjectComponent } from './create-project/create-project.component';
import {
  NgbDropdownModule,
  NgbModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { AttachmentsComponent } from './assignments/attachments/attachments.component';
import { FileService } from 'src/app/core/services/file.service';
import { EditProjectComponent } from './edit-project/edit-project.component';
import { QuillModule } from 'ngx-quill';
import { CommentService } from 'src/app/core/services/comment.service';
import { CommentsComponent } from './assignments/comments/comments.component';
import { AssignmentFollowService } from 'src/app/core/services/assignment-follow.service';
import { AttachmentService } from 'src/app/core/services/attachment.service';
import { CustomQuillEditorComponent } from 'src/app/core/components/custom-quill-editor/custom-quill-editor.component';
import { ProjectFilesComponent } from './project-files/project-files.component';
import { ProjectAttachmentService } from 'src/app/core/services/project-attachment.service';
import { ToastsContainerComponent } from 'src/app/core/components/toast/toasts-container.component';
import { AssignmentReportsComponent } from './assignments/reports/assignment-reports.component';
import { AssignmentReportService } from 'src/app/core/services/assignment-report.service';

@NgModule({
  imports: [
    CommonModule,
    ProjectsRoutingModule,
    ReactiveFormsModule,
    CoreModule,
    NgbTooltipModule,
    NgbDropdownModule,
    NgbModule,
    ToastsContainerComponent,
    CustomQuillEditorComponent,
    QuillModule.forRoot({
        modules: {
            placeholder: true,
        },
        placeholder: '',
    })
],
  providers: [
    ProjectService,
    ProjectAttachmentService,
    AssignmentService,
    AssignmentFollowService,
    FileService,
    CommentService,
    AttachmentService,
    AssignmentReportService,
  ],
  declarations: [
    ProjectsComponent,
    ProjectOverviewComponent,
    CreateProjectComponent,
    EditProjectComponent,
    ProjectFilesComponent,
    CreateAssignmentComponent,
    AssignmentOverviewComponent,
    AttachmentsComponent,
    CommentsComponent,
    AssignmentReportsComponent,
  ],
  exports: [ProjectsComponent],
})
export class ProjectsModule {}
